import React, { useState } from "react";
import logoW from "../../media/images/logo-w.svg";
import { useSelector } from "react-redux";
import Footer from "../../layout/Footer";
import { useDispatch } from "react-redux";
import ChangeForm from "./ChangeForm";

const ResetPassword = () => {
  const [form, setform] = useState("login");
  const { darkTheme } = useSelector((state) => state.styles);

  return (
    <div className="login-page">
      <div className="left-login">
        <div className="logo">
          <img src={logoW} alt="logo" />
        </div>
      </div>
      <div className="right-login">
        <ChangeForm />
      </div>

      <Footer />
    </div>
  );
};

export default ResetPassword;
